import storage from '../private/storage';
import type { ScrollPosition } from './withScrollRestore.interface';

const STORAGE_KEY = 'position';

export interface IScrollPositionStorage {
    id: string;
    get: () => ScrollPosition;
    set: (position: ScrollPosition) => void;
}

const DEFAULT_SCROLL_POSITION: ScrollPosition = Object.freeze({ top: 0, left: 0 });

function _isScrollPosition(object: unknown): object is ScrollPosition {
    const isNullOrUndefined = (value: unknown): boolean => value === null || value === undefined;

    if (isNullOrUndefined(object) || typeof object !== 'object') {
        return false;
    }

    const item = object as Partial<ScrollPosition>;

    return !isNullOrUndefined(item.left) && !isNullOrUndefined(item.top);
}

function _sanitizeScrollPosition(object: ScrollPosition): ScrollPosition {
    return {
        top: Number.isNaN(object.top) ? 0 : Math.round(object.top),
        left: Number.isNaN(object.left) ? 0 : Math.round(object.left),
    };
}

function builder(key: string): IScrollPositionStorage {
    const store = storage(`SCROLL-STATE-${key}`);

    return Object.freeze({
        id: key,
        get: () => {
            const value = store.get(STORAGE_KEY);
            return _isScrollPosition(value)
                ? _sanitizeScrollPosition(value)
                : DEFAULT_SCROLL_POSITION;
        },
        set: (position: ScrollPosition) => {
            store.set(STORAGE_KEY, position);
        },
    });
}

export default builder;
